module.exports = __webpack_public_path__ + "img/top2.07c0b72c.png";